/**
 * C03 §5：`next` 參數必須通過 `isSafeNextPath()`，**只接受以單一 `/` 開頭**的字串，
 * 以防 open redirect。契約明文要求「這條要有單元測試」→ 見 safeNext.test.ts。
 *
 * 被擋掉的典型攻擊：
 *   `//evil.example`        → protocol-relative URL，瀏覽器會當成外部網域
 *   `/\evil.example`        → 部分瀏覽器把 `\` 正規化成 `/`
 *   `https://evil.example`  → 絕對 URL
 *   `javascript:alert(1)`   → scheme 注入
 *   `/ok\u0000/../evil`   → 控制字元，用來繞過字串比對
 */

/** ASCII 控制字元 (U+0000-U+001F) 與 DEL (U+007F)。用碼點判斷而非 regex 字元類，避免原始碼裡出現不可見字元。 */
function hasControlChar(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return true;
  }
  return false;
}

export function isSafeNextPath(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  if (value.length === 0 || value.length > 2048) return false;
  if (hasControlChar(value)) return false;
  // 必須以單一 `/` 開頭
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  // `\` 會被某些瀏覽器正規化成 `/`，等同 protocol-relative
  if (value.includes('\\')) return false;
  return true;
}

/** 不安全就退回預設路徑，永遠不會回傳外部 URL。 */
export function safeNextPathOr(value: unknown, fallback = '/'): string {
  return isSafeNextPath(value) ? value : fallback;
}
